/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Speaker_Assignment_New_OnlyInputs */



/**
* | output |
* | --- |
* | "New Voice Only" |
*
* @param {Options_Editor_Speaker_Assignment_New_OnlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_speaker_assignment_new_only = /** @type {((inputs?: Options_Editor_Speaker_Assignment_New_OnlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Speaker_Assignment_New_OnlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouvelle voix uniquement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur neue Stimme")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solo nuova voce")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Только новый голос")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo nueva voz")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新语音")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しい音声のみ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केवल नई आवाज")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Somente novas vozes")
	return /** @type {LocalizedString} */ ("New Voice Only")
});